import { useState } from "react";
import { useNavigate } from "react-router-dom";

// store
import { messageAndErrorStore, userStore } from "../store/Store";

// assets
import Close from "../assets/close.svg";
import { useEscape } from "../hooks/useEscape";

export default function BatchUpdatePopup({
  reqBody,
  title,
  endpoint,
  successMessage,
  setStates,
  setStateKeys,
  setTrigger,
  otherStates,
  otherStateValues,
}) {
  // store
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // local
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();

  useEscape(setTrigger, [], [], pending);

  const handleSubmit = () => {
    setPending(true);
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(reqBody),
      signal: controller.signal,
    };
    
    fetch(endpoint, requestOptions)
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            setAuthStatus(false);
            setPending(false);
            navigate("/login");
          } else if (res.status === 403) {
            toggleNewMessage("Forbidden: 403");
            setPending(false);
            return Promise.resolve();
          } else {
            toggleNewMessage("Something Went Wrong");
            setPending(false);
            return Promise.resolve();
          }
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (!data) {
          setPending(false);
          setTrigger(false);
          return;
        } else {
          toggleNewMessage(null, successMessage);
          setPending(false);
          setTrigger(false);
          setStates.forEach((st, idx) => {
            if (setStateKeys[idx]=== "") {
              st(data)
            } else {
              st(data[setStateKeys[idx]]);
            }
          });
          if (otherStates && otherStateValues) {
            otherStates.forEach((s, idx) => {
              s(otherStateValues[idx])
            })
          }
        }
      })
      .catch((err) => {
        toggleNewMessage("Something Went Wrong");
        setPending(false);
        console.log(err);
        return;
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner-add-company">
        {!pending && (
          <img src={Close} onClick={() => setTrigger(false)} alt="close" />
        )}
        {title && <p>{title}?</p>}
        {!pending && (
          <button className="delete-btn" onClick={handleSubmit}>
            Yes
          </button>
        )}
        {!pending && (
          <button className="propx-btn" onClick={() => setTrigger(false)}>
            No
          </button>
        )}
        {pending && (
          <button
            className="btn btn-secondary"
            style={{ margin: "20px 20px 20px 0" }}
            disabled
          >
            Submitting...
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        )}
      </div>
    </div>
  );
}
